import { api } from "../api";
import axios from "axios";


export const getUsers = async () => {
    const res = await axios.get(api+'users/',
        {headers: {
            Authorization: 'Bearer '+localStorage.getItem('token'),
            Accept: "application/json",
        }});
    return res.data;
}

export const getUserById = async (userId) => {
    const res = await axios.get(api+'users/'+userId,
        {headers: {
            Authorization: 'Bearer '+localStorage.getItem('token'),
            Accept: "application/json",
        }});
    return res.data;
}



export const addUserS= async({nom,email,password,role,ferme_id}) => {
    await axios.post(api+'users/',{
        nom: nom,
        email: email,
        role: role,
        password: password,
        ferme_id: ferme_id
    },
    {headers: {
            Authorization: 'Bearer '+localStorage.getItem('token'),
            Accept: "application/json",}
})};
export const addUser= async({nom,email,password}) => {
    await axios.post(api+'users/',{
        nom: nom,
        email: email,
        password: password,
    },
    {headers: {
            Authorization: 'Bearer '+localStorage.getItem('token'),
            Accept: "application/json",}
})};

export const updateUserAdmin= async(userId,payload) => {
    const res = await axios.put(api+'users/'+userId, payload,
    {headers: {
            Authorization: 'Bearer '+localStorage.getItem('token'),
           Accept: "application/json", 
}});
    return res.data;
}

export const updateUser= async(userId,payload) => {
    const res = await axios.put(api+'user/'+userId, payload,
    {headers: {
            Authorization: 'Bearer '+localStorage.getItem('token'),
           Accept: "application/json", 
}});
    return res.data;
}

export const deleteUser = async (userId) => {
    await axios.delete(api+'users/'+userId, {headers: {
            Authorization: 'Bearer '+localStorage.getItem('token'),
            Accept: "application/json", 
}});
}
